import labelTemplates from './defaultLabelTemplates';
import rowTemplateThresholds from './defaultRowTemplateThresholds';

export default {
	decimal: '.',
	thousands: ',',
	grouping: [3],
	currency: ['$', ''],
	dateTime: '%a %b %e %X %Y', // %c
	time: '%-I:%M%p', // 12-hour format
	periods: ['am', 'pm'], // %p
	date: '%-m/%-d/%Y', // %x
	days: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'], // %A
	shortDays: ['do.', 'lun.', 'mar.', 'mer.', 'gio.', 'ven.', 'sab.'], // %a
	months: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio ', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'], // %B
	shortMonths: ['genn.', 'febbr.', 'mar.', 'apr.', 'magg.', 'giugno', 'luglio', 'ag.', 'sett.', 'ott.', 'nov', 'dic.'], // %b
	translations: {
		band: {
			overbought: 'Ipercomprato',
			oversold: 'Ipervenduto'
		},
		indicator: {
			previousclose: {
				label: 'Prezzo precedente {0}'
			}
		}
	},
	labelTemplates,
	rowTemplateThresholds
};
